import {HashRouter, Link, Route, Routes, useMatch} from 'react-router-dom'
import Analytics from '../Dashboard/Analytics';
import Topics from "../Dashboard/Topics";
import {useTranslation} from '../../hook/useTranslation'
import {useDashboardAdditionalRoutes} from '../../hook/useRoutes'
import {useNavigationLinkStyles, useStyles} from "./App.styles";

const NavigationLinkItem = ({label, to, activeOnlyWhenExact})=>{
    let match = useMatch({
        path: to,
        exact: activeOnlyWhenExact
    });
    const styles = useNavigationLinkStyles({isActive:match != null})
    return <Link className={styles.link} to={to}>{label}</Link>
}

const App = ()=>{

    const i18n = useTranslation("app");
    const {
        nav_events,
        nav_posts,
        nav_topics,
    } = i18n;
    const styles = useStyles();
    const [customRoutes] = useDashboardAdditionalRoutes();

    return <div className={styles.root}>
        <HashRouter>
            <nav className={styles.nav}>
                <ul className={styles.navList}>
                    <li className={styles.navLi}>
                        <NavigationLinkItem label={nav_events} to="/" activeOnlyWhenExact />
                    </li>
                    <li className={styles.navLi}>
                        <NavigationLinkItem label={nav_topics} to="/topics" activeOnlyWhenExact />
                    </li>
                    {customRoutes.map(({label, path})=><li className={styles.navLi} key={path}>
                        <NavigationLinkItem label={label} to={path} activeOnlyWhenExact />
                    </li>)}
                </ul>
            </nav>
            <div className={styles.content}>
                <Routes>
                    <Route path="/topics" element={<Topics />} />
                    <Route path="/" element={<Analytics />} />
                </Routes>
            </div>
        </HashRouter>
    </div>
}

export default App
